import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Calendar, X } from "lucide-react";
import DatePickerBase from "./DatePickerBase";
import { ensureISODate } from "../../../utils/dateUtils";

const DatePickerModal = ({
  isOpen,
  onClose,
  selectedDate,
  onDateSelect,
  title = "Select Date"
}) => {
  const normalizedValue = ensureISODate(selectedDate);

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50"
          />

          <div className="fixed inset-0 flex items-center justify-center z-[60] p-4 pointer-events-none">
            <motion.div
              initial={{ opacity: 0, scale: 0.95, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: 20 }}
              transition={{ type: "spring", duration: 0.3, bounce: 0.2 }}
              className="bg-gray-900 rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden border border-white/10 pointer-events-auto"
              style={{ maxHeight: "85vh" }}
            >
              <div className="flex items-center justify-between px-6 py-4 border-b border-white/10 bg-black/20">
                <h3 className="text-lg font-semibold text-white flex items-center gap-2">
                  <Calendar size={20} className="text-emerald-400" />
                  {title}
                </h3>
                <button
                  type="button"
                  onClick={onClose}
                  className="p-2 rounded-full hover:bg-white/10 transition-colors"
                  aria-label="Close modal"
                >
                  <X size={20} className="text-white/70" />
                </button>
              </div>

              <DatePickerBase
                value={normalizedValue}
                onChange={onDateSelect}
                onClose={onClose}
                closeOnSelect={false}
              />
            </motion.div>
          </div>
        </>
      )}
    </AnimatePresence>
  );
};

export default DatePickerModal;

